<template>
  <div>
    <b-card>
      <b-row class="mb-3 header">
        <b-col>
          <h5>Brands</h5>
        </b-col>
        <b-col class="text-right">
          <b-button size="sm" variant="secondary" @click="openAddModal">
            + Add
          </b-button>
        </b-col>
      </b-row>
      <content-placeholders v-if="loading">
        <content-placeholders-img
          v-for="n in 6"
          :key="n"
          :style="{ height: '60px', marginBottom: '10px' }"
        />
      </content-placeholders>
      <b-row v-else class="labelBody">
        <div v-for="brand in brands" :key="brand.id" class="currFields">
          <div class="d-flex align-items-center justify-content-between">
            {{ brand.name }}
            <a @click="openEditModal(brand)">
              <i class="fa fa-pencil"></i>
            </a>
          </div>
        </div>
      </b-row>
    </b-card>
    <b-modal ref="brandModal" :title="modalTitle" hide-footer>
      <b-form-group label="Brand name">
        <b-form-input
          v-model="brandName"
          @input="checkDuplicate"
        />
        <small v-if="duplicateError" class="text-danger">
          Brand already exists
        </small>
      </b-form-group>

      <div class="text-right">
        <b-button
          size="sm"
          variant="secondary"
          :disabled="duplicateError || !brandName"
          @click="saveBrand"
        >
          Save
        </b-button>
        <b-button size="sm" variant="light" @click="$refs.brandModal.hide()">
          Cancel
        </b-button>
      </div>
    </b-modal>
  </div>
</template>


<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      brands: [],
      loading: true,
      brandName: '',
      selectedBrand: null,
      duplicateError: false
    }
  },

  computed: {
    ...mapGetters(['idToken']),
    modalTitle () {
      return this.selectedBrand ? 'Edit Brand' : 'Add Brand'
    }
  },

  mounted () {
    this.fetchBrands()
  },

  methods: {
    fetchBrands () {
      this.loading = true
      Vue.axios.get('/brands').then(res => {
        this.brands = res.data
        this.loading = false
      })
    },

    openAddModal () {
      this.brandName = ''
      this.selectedBrand = null
      this.duplicateError = false
      this.$refs.brandModal.show()
    },

    openEditModal (brand) {
      this.brandName = brand.name
      this.selectedBrand = brand
      this.duplicateError = false
      this.$refs.brandModal.show()
    },

    checkDuplicate () {
      this.duplicateError = this.brands.some(
        b =>
          b.name.toLowerCase() === this.brandName.toLowerCase() &&
          (!this.selectedBrand || b.id !== this.selectedBrand.id)
      )
    },

    saveBrand () {
      const payload = { brand: { name: this.brandName } }

      if (this.selectedBrand) {
        Vue.axios
          .patch(`/brands/${this.selectedBrand.id}`, payload, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(res => {
            this.fetchBrands()
            this.$refs.brandModal.hide()
            if (res.status === 200) {
              Vue.toasted.show('Brand Updated', { type: 'success' })
            } else {
              Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            }
          })
      } else {
        Vue.axios.post('/brands', payload).then(res => {
          this.fetchBrands()
          this.$refs.brandModal.hide()
          if (res.status === 201) {
            Vue.toasted.show('Brand Created', { type: 'success' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  cursor: pointer;
  background: #ebeef3;
  border-radius: 10px;
  .bar {
    width: 100%;
    height: 10px;
    border-radius: 10px 10px 0 0;
  }
  .card-header {
  border-radius: 10px 10px 0 0;
    background-color: #f7f7f7;
    padding: 1rem;
  }
}
.currFields {
  float: left;
  width: 33.3%;
  padding: 10px;
  border: 2px solid #f7f7f7;
  background-color: rgb(228, 229, 233) ;
}
.labelBody {
  overflow: scroll;
  background-color: #f7f7f7;
  padding: 10px 4px 10px 10px;
  height:278px;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/brands.vue